import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen flex flex-col">
      <Header />

      <main className="max-w-4xl mx-auto px-6 py-12 bg-white shadow-md rounded-md my-10">
        <h1 className="text-4xl font-bold text-[rgb(0,131,234)] mb-6">Privacy Policy</h1>
        <p className="text-gray-700 mb-4"><strong>Effective Date:</strong> June 25, 2025</p>

        <p className="text-gray-700 mb-4">
          This privacy policy explains how the browser extension <strong>Multiple Screenshots</strong> (“the Extension”, “we”, “our”) collects, uses, and protects your information.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">1. Information We Collect</h2>
        <p className="text-gray-700 mb-4">We only store:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li><strong>Email address:</strong> stored locally in your browser for license activation.</li>
          <li><strong>License token:</strong> used to verify license status through secure calls to our backend (Azure).</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">2. What We Do NOT Collect</h2>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>Browsing history</li>
          <li>Visited URLs</li>
          <li>Captured screenshots</li>
          <li>XPath targets</li>
          <li>User settings or preferences</li>
          <li>Payment information</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">3. Screenshot Data</h2>
        <p className="text-gray-700 mb-4">
          Screenshots are processed entirely on your device. We do not upload or transmit screenshots to any external servers.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">4. Payments</h2>
        <p className="text-gray-700 mb-4">
          We use <strong>Paddle</strong> as our sole payment processor. We do not handle any credit card or billing data directly. Paddle handles all transactions and user payment data.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">5. Backend Communication</h2>
        <p className="text-gray-700 mb-4">
          The extension communicates with our backend hosted on Microsoft Azure only to:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>Verify license tokens</li>
          <li>Store user email addresses for account association</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">6. Data Storage</h2>
        <p className="text-gray-700 mb-4">
          All data is stored locally within the extension using `chrome.storage.local`. No persistent server-side storage of user behavior or content occurs.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">7. Your Control</h2>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>You may remove your license and email by logging out in the extension.</li>
          <li>Uninstalling the extension removes all local data.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">8. Compliance</h2>
        <p className="text-gray-700 mb-4">
          We comply with GDPR and CCPA. Since no personal usage data is transmitted, your use of the extension is private by default.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">9. Contact</h2>
        <p className="text-gray-700 mb-4">Questions? Contact us at <a className="text-[rgb(0,131,234)] font-medium" href="mailto:kontakt@wentago.pl">kontakt@wentago.pl</a></p>

        <p className="text-sm text-gray-500 mt-8">Last updated: July 29, 2025</p>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
